<template>
  <div>
    <div class="container-buttons-report mb-1">
      <div class="align-content-end"></div>
      <div>
        <div class="noprint">
          <div class="d-flex ml-auto">
            <div
              class="d-flex"
              v-if="assessment_group_report && assessment_group_report.sections"
            >
              <div class="ml-auto mr-0 d-flex">
                <strong
                  class="mr-2 align-content-center"
                  style="font-size: 10pt"
                >
                  {{ $t("toolbar.reports.formative").toUpperCase() }}
                </strong>
                <b-form-checkbox
                  class="align-content-center"
                  v-model="assessment_switches_type"
                  switch
                >
                  <strong style="font-size: 10pt">{{
                    $t("toolbar.reports.summative").toUpperCase()
                  }}</strong>
                </b-form-checkbox>
              </div>
            </div>
            <GenericButtonDownload
              v-if="
                !is_loading &&
                assessment_group_report &&
                assessment_group_report.sections &&
                assessment_group_report.sections.length
              "
              :tooltip_text="$t('toolbar.reports.reportXlsx')"
              :click_button="DownloadExcel"
              :class="`ml-1`"
              :disabled_button="disabled_button_excel"
              :icon_excel="true"
            ></GenericButtonDownload>
          </div>
        </div>
      </div>
    </div>

    <!-- b-table -->
    <b-skeleton-table
      v-if="is_loading"
      :rows="9"
      :columns="10"
      :table-props="{ bordered: true, striped: true }"
    ></b-skeleton-table>
    <div class="table-wrapper">
      <b-table-simple
        bordered
        small
        responsive
        v-if="
          !is_loading &&
          assessment_group_report &&
          assessment_group_report.sections &&
          assessment_group_report.achievement_ranges
        "
        class="table-wrapper table-assesment"
      >
        <b-thead>
          <b-tr>
            <b-th
              class="text-center align-middle primary-header"
              :colspan="
                2 +
                (assessment_group_report.achievement_ranges.length + 1) *
                  2 *
                  assessment_group_report.study_units.length
              "
            >
              <div class="d-flex align-items-center justify-content-between">
                <span class="text-center mx-auto">
                  {{
                    $getVisibleNames(
                      "manual.reporte.assessment_group_ra_micro",
                      false,
                      $t("toolbar.reports.assessmentGroupRaMicroReportTitle", {
                        raMicro: $getVisibleNames(
                          "teaching.ramicro",
                          false,
                          "RA Micro"
                        ),
                        egressProfile: $getVisibleNames(
                          "mesh.egressprofile",
                          false,
                          "Perfil de egreso"
                        ),
                      })
                    ).toUpperCase()
                  }}
                </span>
                <VisibleColumns
                  v-if="displayList.length > 0"
                  :id_button="`col-display-1`"
                  :tooltip_text="''"
                >
                  <template #popover-title>
                    {{ $t("toolbar.reports.visualizeColumns") }}
                  </template>
                  <template #popover-content>
                    <template v-if="assessment_group_report != null">
                      <div class="visible_columns">
                        <template v-for="display in displayList">
                          <div
                            :key="'index' + display.index + 'id' + display.id"
                          >
                            <div class="noprint">
                              <b-form-checkbox
                                :id="`column-check-${display.index}`"
                                name="checkbox-1"
                                v-model="display.visible"
                                :disabled="
                                  displayList.filter(
                                    (a) => a.visible && a.id != display.id
                                  ).length < 1 && display.visible
                                "
                              >
                                {{ display.title }}
                                {{ display.order ? display.order : "" }}
                              </b-form-checkbox>
                            </div>
                          </div>
                        </template>
                      </div>
                    </template>
                  </template>
                </VisibleColumns>
              </div>
            </b-th>
          </b-tr>
          <b-tr>
            <b-th
              class="text-center align-middle secondary-header"
              rowspan="3"
              v-if="
                displayList.some(
                  (x) =>
                    $equals(
                      x.title,
                      $getVisibleNames(
                        'mesh.egressprofilematter',
                        true,
                        'Asignaturas'
                      ).toUpperCase()
                    ) && x.visible
                )
              "
            >
              {{
                $getVisibleNames(
                  "mesh.egressprofilematter",
                  true,
                  "Asignaturas"
                ).toUpperCase()
              }}
            </b-th>
            <b-th
              class="text-center align-middle secondary-header"
              v-if="
                displayList.some(
                  (x) =>
                    $equals(
                      x.title,
                      $getVisibleNames(
                        'teaching.section',
                        true,
                        'secciones'
                      ).toUpperCase()
                    ) && x.visible
                )
              "
              rowspan="3"
            >
              {{
                $getVisibleNames(
                  "teaching.section",
                  true,
                  "secciones"
                ).toUpperCase()
              }}
            </b-th>
            <template
              v-for="assessment_label in assessment_group_report.study_units"
            >
              <b-th
                v-if="
                  displayList.some(
                    (x) =>
                      $equals(
                        `${x.id} ${x.title}`,
                        `${
                          assessment_label.id
                        } ${assessment_label.short_name.toUpperCase()}`
                      ) && x.visible
                  )
                "
                :colspan="
                  (assessment_group_report.achievement_ranges.length + 1) * 2
                "
                v-b-tooltip.v-secondary.noninteractive="
                  `${assessment_label.full_sentence}`
                "
                class="text-center align-middle secondary-header cursor-pointer"
                :key="`header-assessment-${assessment_label.id}`"
                :id="`header-assessment-top-${assessment_label.id}`"
              >
                {{ assessment_label.short_name.toUpperCase() }}
              </b-th>
            </template>
          </b-tr>
          <b-tr>
            <template v-for="study_unit in assessment_group_report.study_units">
              <template
                v-for="assessment_label in assessment_group_report.achievement_ranges"
              >
                <b-th
                  v-if="
                    displayList.some(
                      (x) =>
                        $equals(
                          `${x.id} ${x.title}`,
                          `${
                            study_unit.id
                          } ${study_unit.short_name.toUpperCase()}`
                        ) && x.visible
                    )
                  "
                  colspan="2"
                  v-b-tooltip.v-secondary.noninteractive="
                    `${assessment_label.start_achievement} ${
                      assessment_label.include_start_achievement ? '≤' : '<'
                    } X ${
                      assessment_label.include_finish_achievement ? '≤' : '<'
                    } ${assessment_label.finish_achievement}`
                  "
                  class="text-center align-middle secondary-header cursor-pointer"
                  :style="`background-color:${assessment_label.color} !important`"
                  :key="`header-assessment-${assessment_label.id}-${study_unit.id}`"
                  :id="`header-assessment-top-${assessment_label.id}-${study_unit.id}`"
                >
                  {{ assessment_label.name.toUpperCase() }}
                </b-th>
              </template>
              <b-th
                :key="`header-assessment--${study_unit.id}`"
                colspan="2"
                v-if="
                  displayList.some(
                    (x) =>
                      $equals(
                        `${x.id} ${x.title}`,
                        `${
                          study_unit.id
                        } ${study_unit.short_name.toUpperCase()}`
                      ) && x.visible
                  )
                "
                class="text-center align-middle secondary-header"
                >{{ $t("toolbar.reports.noRecord").toUpperCase() }}</b-th
              >
            </template>
          </b-tr>
          <b-tr>
            <template v-for="study_unit in assessment_group_report.study_units">
              <template
                v-for="assessment_label in assessment_group_report.achievement_ranges"
              >
                <b-th
                  v-if="
                    displayList.some(
                      (x) =>
                        $equals(
                          `${x.id} ${x.title}`,
                          `${
                            study_unit.id
                          } ${study_unit.short_name.toUpperCase()}`
                        ) && x.visible
                    )
                  "
                  class="text-center align-middle secondary-header cursor-pointer"
                  v-b-tooltip.v-secondary.noninteractive="
                    $t('toolbar.reports.quantityPercentage')
                  "
                  :key="`header-assessment-3-cant${assessment_label.id}-${study_unit.id}`"
                  :id="`header-assessment-top-3-cant${assessment_label.id}-${study_unit.id}`"
                >
                  {{ $t("toolbar.reports.cant") }}
                </b-th>
                <b-th
                  v-if="
                    displayList.some(
                      (x) =>
                        $equals(
                          `${x.id} ${x.title}`,
                          `${
                            study_unit.id
                          } ${study_unit.short_name.toUpperCase()}`
                        ) && x.visible
                    )
                  "
                  class="text-center align-middle secondary-header cursor-pointer"
                  v-b-tooltip.v-secondary.noninteractive="
                    $t('toolbar.reports.percentage')
                  "
                  :key="`header-assessment-3-%${assessment_label.id}-${study_unit.id}`"
                  :id="`header-assessment-top-3-%${assessment_label.id}-${study_unit.id}`"
                >
                  {{ $t("toolbar.reports.percentageSymbol") }}
                </b-th>
              </template>
              <b-th
                v-if="
                  displayList.some(
                    (x) =>
                      $equals(
                        `${x.id} ${x.title}`,
                        `${
                          study_unit.id
                        } ${study_unit.short_name.toUpperCase()}`
                      ) && x.visible
                  )
                "
                class="text-center align-middle secondary-header cursor-pointer"
                v-b-tooltip.v-secondary.noninteractive="
                  $t('toolbar.reports.quantityPercentage')
                "
                :key="`header-assessment-4-cant${study_unit.id}`"
                :id="`header-assessment-top-4-cant${study_unit.id}`"
              >
                {{ $t("toolbar.reports.cant") }}
              </b-th>
              <b-th
                v-if="
                  displayList.some(
                    (x) =>
                      $equals(
                        `${x.id} ${x.title}`,
                        `${
                          study_unit.id
                        } ${study_unit.short_name.toUpperCase()}`
                      ) && x.visible
                  )
                "
                class="text-center align-middle secondary-header cursor-pointer"
                v-b-tooltip.v-secondary.noninteractive="
                  $t('toolbar.reports.percentage')
                "
                :key="`header-assessment-4-%${study_unit.id}`"
                :id="`header-assessment-top-4-%${study_unit.id}`"
              >
                {{ $t("toolbar.reports.percentageSymbol") }}
              </b-th>
            </template>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="(assessment, index) in assessment_group_report.sections"
            :key="`row-${assessment.id}-${index}`"
          >
            <!-- Asignaturas -->
            <b-td
              v-if="
                displayList.some(
                  (x) =>
                    $equals(
                      x.title,
                      $getVisibleNames(
                        'mesh.egressprofilematter',
                        true,
                        'Asignaturas'
                      ).toUpperCase()
                    ) && x.visible
                )
              "
              class="text-left"
            >
              {{ egress_profile_matter.matter_name }}
            </b-td>
            <!-- Sección -->
            <b-td
              v-if="
                displayList.some(
                  (x) =>
                    $equals(
                      x.title,
                      $getVisibleNames(
                        'teaching.section',
                        true,
                        'secciones'
                      ).toUpperCase()
                    ) && x.visible
                )
              "
              class="text-left"
            >
              <span
                :id="`popover-section-${assessment.section_id}-${index}`"
                class="div-href"
              >
                {{ assessment.section_name }}
              </span>
              <b-popover
                :target="`popover-section-${assessment.section_id}-${index}`"
                triggers="hover"
              >
                <template #title>{{ $t("toolbar.reports.navigation") }}:</template>
                <div>
                  <template>
                    <div class="profiles-container">
                      <b-button
                        variant="secondary"
                        @click="redirectToSection(assessment.section_id)"
                        @contextmenu.prevent="handleRightClickSection(assessment.section_id)"
                        class="btn-popover-my-classes mb-2 w-100"
                      >
                        {{
                          $t("toolbar.reports.sectionGrades", {
                            section: $getVisibleNames(
                              "teaching.section",
                              false,
                              "Sección"
                            ),
                          })
                        }}
                      </b-button>
                      <b-button
                        variant="secondary"
                        @click="redirectToEvaluationTeacher(assessment.section_id)"
                        @contextmenu.prevent="handleRightClickEvaluationTeacher(assessment.section_id)"
                        class="btn-popover-my-classes mb-2 w-100"
                      >
                        {{
                          $t("toolbar.reports.sectionEvaluations", {
                            evaluations: $getVisibleNames(
                              "evaluations2.evaluation",
                              true,
                              "Evaluaciones"
                            ),
                            section: $getVisibleNames(
                              "teaching.section",
                              false,
                              "Sección"
                            ),
                          })
                        }}
                      </b-button>
                    </div>
                  </template>
                </div>
              </b-popover>
            </b-td>
            <template v-for="study_unit in assessment.study_units">
              <template
                v-for="(
                  assessment_label, index
                ) in study_unit.achievement_ranges"
              >
                <b-td
                  :key="`study_unit:${study_unit.id}-achievement_ranges${index}`"
                  v-if="
                    displayList.some(
                      (x) =>
                        $equals(
                          `${x.id} ${x.title}`,
                          `${
                            study_unit.id
                          } ${study_unit.short_name.toUpperCase()}`
                        ) && x.visible
                    )
                  "
                  class="text-center"
                >
                  <div v-if="assessment_switches_type">
                    {{ assessment_label.range_count_summative | Round }}
                  </div>
                  <div v-else>
                    {{ assessment_label.range_count_formative | Round }}
                  </div>
                </b-td>
                <b-td
                  :key="`study_unit:${study_unit.id}-achievement_ranges${index}-%`"
                  v-if="
                    displayList.some(
                      (x) =>
                        $equals(
                          `${x.id} ${x.title}`,
                          `${
                            study_unit.id
                          } ${study_unit.short_name.toUpperCase()}`
                        ) && x.visible
                    )
                  "
                  class="text-center"
                >
                  <div v-if="assessment_switches_type">
                    {{ assessment_label.range_percentage_summative | Round }}%
                  </div>
                  <div v-else>
                    {{ assessment_label.range_percentage_formative | Round }}%
                  </div>
                </b-td>
              </template>
              <!-- SIN REGISTRO -->

              <b-td
                :key="`study_unit:${study_unit.id}-Cant`"
                class="text-center"
                v-if="
                  displayList.some(
                    (x) =>
                      $equals(
                        `${x.id} ${x.title}`,
                        `${
                          study_unit.id
                        } ${study_unit.short_name.toUpperCase()}`
                      ) && x.visible
                  )
                "
              >
                <div v-if="assessment_switches_type">
                  {{ study_unit.unregistered_count_summative | Round }}
                </div>
                <div v-else>
                  {{ study_unit.unregistered_count_formative | Round }}
                </div>
              </b-td>
              <b-td
                :key="`study_unit:${study_unit.id}-%`"
                class="text-center"
                v-if="
                  displayList.some(
                    (x) =>
                      $equals(
                        `${x.id} ${x.title}`,
                        `${
                          study_unit.id
                        } ${study_unit.short_name.toUpperCase()}`
                      ) && x.visible
                  )
                "
              >
                <div v-if="assessment_switches_type">
                  {{ study_unit.unregistered_percentage_summative | Round }}%
                </div>
                <div v-else>
                  {{ study_unit.unregistered_percentage_formative | Round }}%
                </div>
              </b-td>
            </template>
          </b-tr>
          <b-tr v-if="assessment_group_report.sections.length == 0">
            <b-td :colspan="displayList.length">
              {{ $t("toolbar.reports.noDataToDisplay") }}
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <b-table-simple
        bordered
        small
        responsive
        v-if="
          assessment_group_report &&
          assessment_group_report.sections &&
          assessment_group_report.sections.length > 0 &&
          assessment_group_report.study_units &&
          assessment_group_report.study_units.length > 0
        "
        class="table-assesment-range-print"
      >
        <b-thead>
          <b-th
            class="text-center align-middle primary-header"
            colspan="2"
          ></b-th>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="study_unit in assessment_group_report.study_units"
            :key="`print-table-${study_unit.id}`"
          >
            <b-td class="text-left">{{ study_unit.short_name }} </b-td>
            <b-td class="text-left">{{ study_unit.full_sentence }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <!-- Grafico -->
      <GenericGraphic
        v-if="sectionOptions.length > 0"
        :labels="chartLabels"
        :datasets="chartDatasets"
        :legend_labels="legendLabels"
        :title_graphic="
          $t('toolbar.reports.assessmentGroupRaMicroByMatterReportTitle', {
            raMicro: $getVisibleNames('teaching.ramicro', true, 'RA MICRO'),
            matter: $getVisibleNames(
              'mesh.egressprofilematter',
              false,
              'Asignatura'
            ),
          }).toUpperCase()
        "
        :total_students="totalStudents"
        :label_y_axis="$t('toolbar.reports.numberOfStudents')"
        :title_table_circular="$t('toolbar.reports.assessment')"
        :selected_assessment="selected_assessment"
      >
        <template #selector>
          <div class="d-flex">
            <!-- Selector de sección -->
            <b-form-select
              id="sectionSelector"
              v-model="selected_section"
              :options="sectionOptions"
              @change="updateSection"
              class="select-section-type mr-3"
            ></b-form-select>
            <b-form-select
              v-if="selected_section != null"
              id="assessmentSelector"
              v-model="selected_assessment"
              :options="assessmentOptions"
              @change="updateAssessment"
            ></b-form-select>
            <b-tooltip
              v-if="
                selected_assessment != 'compare_all' &&
                getCurrentTooltip(selected_assessment)
              "
              target="assessmentSelector"
              triggers="hover"
              placement="right"
              boundary="window"
            >
              {{ getCurrentTooltip(selected_assessment) }}
            </b-tooltip>
          </div>
        </template>
      </GenericGraphic>
    </div>
  </div>
</template>

<script>
// import * as names from "@/store/names";
import { mapGetters } from "vuex";
import {
  showLoadingAlert,
  downloadFileFromResponse,
  EventBus,
} from "@/utils/utils";
export default {
  name: "AssessmentGroupStudyUnitTable",
  components: {
    VisibleColumns: () =>
      import("@/components/reusable/Buttons/VisibleColumns"),
    GenericButtonDownload: () =>
      import("@/components/reusable/Buttons/GenericButtonDownload"),
    GenericGraphic: () => import("@/components/reusable/GenericGraphic"),
  },
  props: {
    egress_profile: {
      type: Object,
      required: true,
    },
    egress_profile_matter: {
      type: Object,
      required: true,
    },
    achievement_range_group: {
      type: [Number, null],
      required: false,
      default: null,
    },
    cohorts_: {
      type: Array,
      required: true,
    },
    cohort_indices_: {
      type: Array,
      default: () => [],
    },
    cycles_: {
      type: Array,
    },
    periods_: {
      type: Array,
    },
    levels_: {
      type: Array,
    },
    sections_: {
      type: Array,
    },
    student_status_: {
      type: Array,
      default: () => [],
    },
    title_graphic: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      is_loading: false, // Variable para mostrar "skeletons"
      disabled_button_excel: false,
      assessment_group_report: [],
      displayList: [],
      assessment_switches_type: true,
      selected_assessment: "compare_all", // Variable para guardar assessment del selector.
      selected_section: null,
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
    }),
    isOnTrack() {
      const student_status_ids = this.student_status_.map((x) => x.id);
      if (student_status_ids.includes(1) && student_status_ids.includes(2))
        return null;
      else if (student_status_ids.includes(1)) return true;
      else if (student_status_ids.includes(2)) return false;
      return null;
    },
    sectionOptions() {
      if (!this.assessment_group_report?.sections) return [];

      const options = [];

      options.push({
        value: null,
        text: this.$t("toolbar.reports.selectSection"),
      });

      this.assessment_group_report.sections.forEach((x) => {
        options.push({
          value: x.section_id,
          text: x.section_name,
        });
      });

      return options;
    },
    assessmentOptions() {
      if (!this.assessment_group_report?.sections || !this.selected_section)
        return [];

      // Sección seleccionada
      const selectedSection = this.assessment_group_report.sections.find(
        (section) => section.section_id == this.selected_section
      );

      if (!selectedSection) return [];

      // Generar los study_units segun la sección seleccionada
      const options = selectedSection.study_units.map((studyUnit) => ({
        value: studyUnit.id,
        text: `${studyUnit.short_name}`.trim(),
      }));

      // Añadir opción "Comparar todos"
      options.push({
        value: "compare_all",
        text: this.$t("toolbar.reports.viewAll", {
          assessmentType:
            selectedSection.study_units[0]?.short_name_assessment_type || "",
        }),
      });

      return options;
    },
    totalStudents() {
      if (!this.assessment_group_report?.sections || !this.selected_section)
        return 0;

      const selectedSection = this.assessment_group_report.sections.find(
        (x) => x.section_id == this.selected_section
      );

      return selectedSection?.evaluatee_count || 0;
    },
    // Etiquetas del gráfico (eje X)
    chartLabels() {
      if (!this.assessment_group_report?.sections || !this.selected_section)
        return [];

      const selectedSection = this.assessment_group_report.sections.find(
        (section) => section.section_id == this.selected_section
      );

      if (!selectedSection) return [];

      if (this.selected_assessment == "compare_all") {
        return selectedSection.study_units.map(
          (studyUnit) => `${studyUnit.short_name}`
        );
      }

      // Para la opción individual se mostra el short_name
      const selected = selectedSection.study_units.find(
        (x) => x.id == this.selected_assessment
      );
      return selected ? [`${selected.short_name}`] : [];
    },

    // Datos del gráfico (eje Y)
    chartDatasets() {
      if (
        !this.assessment_group_report?.achievement_ranges ||
        !this.selected_section ||
        !this.selected_assessment
      ) {
        return [];
      }

      // Se busca la sección seleccionada
      const selectedSection = this.assessment_group_report.sections.find(
        (section) => section.section_id == this.selected_section
      );

      if (!selectedSection) return [];

      const datasets = [];

      // Si se selecciona "Comparar todos"
      if (this.selected_assessment == "compare_all") {
        // Crear un dataset por cada achievement_range
        this.assessment_group_report.achievement_ranges.forEach((range) => {
          const data = selectedSection.study_units.map((studyUnit) => {
            const matchingRange = studyUnit.achievement_ranges.find(
              (x) => x.id == range.id
            );
            return matchingRange
              ? this.assessment_switches_type
                ? matchingRange.range_count_summative
                : matchingRange.range_count_formative
              : 0;
          });

          datasets.push({
            label: range.name, // Nombre del rango
            data: data, // Datos para el gráfico
            backgroundColor: range.color, // Color del achievement_range
          });
        });

        // Agregar dataset para los sin Registro
        const unregisteredData = selectedSection.study_units.map((studyUnit) =>
          this.assessment_switches_type
            ? studyUnit.unregistered_count_summative
            : studyUnit.unregistered_count_formative
        );

        datasets.push({
          label: this.$t("toolbar.reports.noRecord"), // Etiqueta para los sin Registro
          data: unregisteredData, // Datos de sin Registro
          backgroundColor: "#cccccc", // Color gris para diferenciar
        });
      } else {
        // Si se selecciona una opción individual
        const selected = selectedSection.study_units.find(
          (x) => x.id == this.selected_assessment
        );

        if (selected) {
          // Crear un dataset por cada achievement_range para el study_unit seleccionado
          this.assessment_group_report.achievement_ranges.forEach((range) => {
            const matchingRange = selected.achievement_ranges.find(
              (x) => x.id == range.id
            );

            datasets.push({
              label: range.name,
              data: [
                matchingRange
                  ? this.assessment_switches_type
                    ? matchingRange.range_count_summative
                    : matchingRange.range_count_formative
                  : 0,
              ],
              backgroundColor: range.color,
            });
          });

          // Agregar dataset para los sin Registro
          datasets.push({
            label: this.$t("toolbar.reports.noRecord"),
            data: [
              this.assessment_switches_type
                ? selected.unregistered_count_summative
                : selected.unregistered_count_formative,
            ],
            backgroundColor: "#cccccc",
          });
        }
      }

      return datasets;
    },
    legendLabels() {
      if (
        this.assessment_group_report &&
        this.assessment_group_report.achievement_ranges
      ) {
        // Devuelve los nombres de los rangos
        const labels = this.assessment_group_report.achievement_ranges.map(
          (x) => ({
            label: x.name,
            color: x.color,
          })
        );

        // Añadir la etiqueta para los sin Registro
        labels.push({
          label: this.$t("toolbar.reports.noRecord"), // Etiqueta para los sin Registro
          color: "#cccccc", // Color gris para los sin Registro
        });

        return labels;
      }
      return [];
    },
  },
  methods: {
    redirectToSection(id) {
      this.$router.push({
        name: "NewFullGradingView",
        params: { section_id: id },
      });
    },
    handleRightClickSection(id) {
      const url = this.$router.resolve({
        name: "NewFullGradingView",
        params: { section_id: id },
      }).href;
      window.open(url, "_blank");
    },
    redirectToEvaluationTeacher(id) {
      this.$router.push({
        name: "EvaluatorEvaluationsListView",
        params: { section_id: id },
      });
    },
    handleRightClickEvaluationTeacher(id) {
      const url = this.$router.resolve({
        name: "EvaluatorEvaluationsListView",
        params: { section_id: id },
      }).href;
      window.open(url, "_blank");
    },
    getCurrentTooltip(assessmentId) {
      if (assessmentId == "compare_all" || !assessmentId) return null;
      const assessment = this.assessment_group_report?.study_units.find(
        (x) => x.id == assessmentId
      );
      return assessment?.full_sentence || null;
    },
    updateSection(selectedId) {
      this.selected_section = selectedId;
      this.selected_assessment = "compare_all";
    },
    updateAssessment(selectedId) {
      this.selected_assessment = selectedId;
    },
    completeDisplayList(response) {
      this.displayList = [
        {
          index: 0,
          id: this.$getVisibleNames(
            "mesh.egressprofilematter",
            true,
            "Asignaturas"
          ).toUpperCase(),
          title: this.$getVisibleNames(
            "mesh.egressprofilematter",
            true,
            "Asignaturas"
          ).toUpperCase(),
          visible: true,
        },
        {
          index: 1,
          id: this.$getVisibleNames(
            "teaching.section",
            true,
            "secciones"
          ).toUpperCase(),
          title: this.$getVisibleNames(
            "teaching.section",
            true,
            "secciones"
          ).toUpperCase(),
          visible: true,
        },
      ];
      let display_index = this.displayList.length;
      if (response.study_units && response.study_units.length > 0)
        response.study_units.forEach((element) => {
          this.displayList.push({
            index: display_index,
            id: element.id,
            title: `${element.short_name.toUpperCase()}`,
            order: "",
            visible: true,
          });
          display_index += 1;
        });
    },
    getAssessmentRange() {
      this.is_loading = true;
      this.displayList = [];
      //   period: this.periods_[0].id,
      this.$restful
        .Post(`/assessment2/group_study_unit_report/`, {
          egress_profile_matter: this.egress_profile_matter.id,
          cohort_year_filter_ids: this.cohorts_.map((x) => x.cohort),
          cohort_index_filter_ids: this.cohort_indices_.map(
            (x) => x.cohort_index
          ),
          is_on_track: this.isOnTrack,
          achievement_range_group: this.achievement_range_group,
          sections: this.sections_.map((x) => x.id),
        })
        .then((response) => {
          this.assessment_group_report = response;
          this.completeDisplayList(response);
          this.$swal.close();
          EventBus.$emit("report_request_finished");
          this.is_loading = false;
        })
        .catch(() => {
          this.is_loading = false;
          this.$swal.close();
          EventBus.$emit("report_request_finished");
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
    DownloadExcel() {
      this.disabled_button_excel = true;
      showLoadingAlert(
        this.$t("reusable.common.generatingExcel"),
        this.$t("reusable.common.pleaseWaitFile")
      );
      //   period: this.periods_[0].id,
      this.$restful
        .Post(
          `assessment2/excel_report_group_study_unit_report/`,
          {
            egress_profile_matter: this.egress_profile_matter.id,
            cohort_year_filter_ids: this.cohorts_.map((x) => x.cohort),
            cohort_index_filter_ids: this.cohort_indices_.map(
              (x) => x.cohort_index
            ),
            is_on_track: this.isOnTrack,
            level_filters: this.levels_.map((x) => x.id),
            period_filters: this.periods_[0].id,
            achievement_range_group: this.achievement_range_group,
            sections: this.sections_.map((x) => x.id),
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.$swal.close();
          if (response) {
            downloadFileFromResponse(
              response,
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              () => {
                this.disabled_button_excel = false;
              },
              () => {
                this.disabled_button_excel = false;
                this.$swal.fire(
                  this.$t("reusable.common.error"),
                  this.$t("reusable.common.downloadError"),
                  "error"
                );
              }
            );
          } else {
            this.disabled_button_excel = false;
            this.$swal.fire(
              this.$t("reusable.common.error"),
              this.$t("reusable.common.generateError"),
              "error"
            );
          }
        })
        .catch(() => {
          this.disabled_button_excel = false;
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
  },
  created() {
    this.getAssessmentRange();
  },
};
</script>

<style scoped>
.select-section-type {
  width: auto;
}
.container-buttons-report {
  display: flex;
  justify-content: right;
}
.primary-header {
  background-color: var(--kl-color-accent-medium) !important;
  color: white;
}
.secondary-header {
  background: var(--kl-table-header-bg) !important;
  color: var(--kl-table-header-text);
}
.col-display-1,
.col-display-2 {
  min-width: 200px;
  margin-left: 2em;
  background-color: var(--kl-primary-button-color) !important;
  color: #fff;
}
.col-display-1:hover,
.col-display-2:hover {
  background-color: var(--kl-primary-button-hover-color) !important;
  transition: all 0.3s;
}
.truncated-text {
  white-space: nowrap; /* Evita el salto de línea */
  overflow: hidden; /* Oculta el contenido que se desborda */
  text-overflow: ellipsis; /* Agrega "..." al final */
  width: 100%; /* Asegura que no sobrepase el contenedor */
}
.div-href {
  color: #007bff;
}
.div-href:hover {
  color: #0057b1 !important;
  text-decoration: underline;
  cursor: pointer;
}
.visible_columns {
  max-height: 300px;
  overflow: auto;
}
.cursor-pointer {
  cursor: help;
}

/* Table wrapper styles with max height and scroll */
.table-wrapper {
  max-width: 100%;
  max-height: 80vh;
  overflow: auto;
  border: 1px solid var(--kl-table-border);
  border-radius: 8px;
  margin: 20px 0;
}

@media (max-width: 768px) {
  .table-assesment-range-table {
    width: 100%;
    min-width: 600px;
    border-collapse: collapse; /* Evita que las celdas se sobrepongan */
  }
  .table-assesment {
    width: 100%;
    min-width: 800px;
    border-collapse: collapse; /* Evita que las celdas se sobrepongan */
  }
}
/* .table-assesment-print-table {
  display: none;
} */

@media print {
  .table-assesment-print-table {
    display: block;
  }
  .badge {
    border: none;
  }
}
</style>

